import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.array.map";
import "core-js/modules/es6.array.some";
import { __rest } from "tslib";
import * as React from 'react';
import { css } from '@patternfly/react-styles';
import styles from '@patternfly/react-styles/css/components/Table/table';
import { mapOpenedRows } from './utils/headerUtils';
export var BodyWrapper = function BodyWrapper(_a) {
  var mappedRows = _a.mappedRows,
      tbodyRef = _a.tbodyRef,
      _a$rows = _a.rows,
      rows = _a$rows === void 0 ? [] : _a$rows,
      onCollapse = _a.onCollapse,
      headerRows = _a.headerRows,
      props = __rest(_a, ["mappedRows", "tbodyRef", "rows", "onCollapse", "headerRows"]);

  if (mappedRows && mappedRows.some(function (row) {
    return row.hasOwnProperty('parent');
  })) {
    return React.createElement(React.Fragment, null, mapOpenedRows(mappedRows, props.children).map(function (oneRow, key) {
      return React.createElement("tbody", Object.assign({}, props, {
        className: css(oneRow.isOpen && styles.modifiers.expanded),
        key: "tbody-".concat(key),
        ref: tbodyRef
      }), oneRow.rows);
    }));
  }

  return React.createElement("tbody", Object.assign({}, props, {
    ref: tbodyRef
  }));
};
BodyWrapper.displayName = 'BodyWrapper';